import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import { MotionPlugin } from '@vueuse/motion'
import { useWindowStore } from '@/stores/window'

const app = createApp(App)

import installIcon from '@/views/flyflow/utils/icon'
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $icon: object
  }
}
//打印
import print from 'vue3-print-nb'
app.use(createPinia())
app.use(router)
app.use(print)
app.use(installIcon)
app.use(ElementPlus)
app.use(MotionPlugin)

app.mount('#app')
//窗口变化了
window.onresize = () => {
  return (() => {
    useWindowStore().setChangedTime('window')
  })()
}
